import styled from "@emotion/styled";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";

export const SideSkeleton = styled(StyledAnimatedSkeleton)`
  height: 301px;
  width: 186px;
`;

export const CenterSkeleton = styled(StyledAnimatedSkeleton)`
  height: 86px;
  width: 563px;
`;
